import React from 'react'
import { Link, NavLink } from 'react-static'
import styled, { injectGlobal } from 'styled-components'

const darkblue = `rgba(23, 104, 172, 1)`
const lightblue = `rgba(6, 190, 225, 1)`
const pink = `#FF6B98`
const activeLink = { borderBottom: '4px solid #FF6B98' }
const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-top: 2px solid ${darkblue};
  padding: 20px 0 10px 0;
  text-align: center;
  a {
    font-family: 'Raleway';
    font-weight: 100;
    margin-bottom: 10px;
    color: ${lightblue};
    text-align: center;
    transition: all 500ms ease;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
    &:not(:last-child) {
      margin-right: 30px;
    }
    &:hover {
      text-decoration: none;
      border-bottom: 4px solid ${pink};
    }
  }
`
const Navigation = () => (
  <Nav>
    <NavLink exact to="/" activeStyle={activeLink}>
      Home
    </NavLink>
    <NavLink to="/work" activeStyle={activeLink}>
      Work
    </NavLink>
  </Nav>
)
export default Navigation



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Navigation.js